import whatsapp from "../../assets/whatsapp.svg"


const icons = [
  {
    name: "WhatsApp",
    link: "https://wa.me/32984527181",
    url: whatsapp

  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/wellington-eduardo",
    url: "https://cdn.simpleicons.org/linkedin"

  }
  ,
  {
    name: "GitHub",
    link: "https://github.com/WellingtonEduardo",
    url: "https://cdn.simpleicons.org/github/white"

  }




];


export default icons